import styled from 'styled-components';

import { mediaConfined } from '@xingternal/layout-tokens';
import { space3XL, spaceXL, spaceXXL } from '@xingternal/tokens';

import { MarketingIllustration as MarketingIllustrationComponent } from './marketing-illustration';

export const HeroWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  margin-bottom: ${spaceXXL};
  margin-top: ${spaceXL};

  @media ${mediaConfined} {
    flex-direction: row;
    gap: ${space3XL};

    margin-bottom: ${space3XL};
    margin-top: 40px;
  }
`;

export const MarketingIllustration = styled(MarketingIllustrationComponent)`
  max-height: 210px;

  @media ${mediaConfined} {
    max-height: 333px;
  }
`;
